import { render } from "./AccessOnTimeByCustomer.vue?vue&type=template&id=2cd6a33e"
import script from "./AccessOnTimeByCustomer.vue?vue&type=script&lang=js"
export * from "./AccessOnTimeByCustomer.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/potabilis/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__